import { AbstractControl, ValidationErrors } from '@angular/forms';
import { GiftUnlockMode } from './gift-unlock.component';

export const MAXX_AI_RANGE_REQUIRED = 'maxxAiRangeRequired';
export const MAXX_AI_RANGE_INVALID = 'maxxAiRangeInvalid';

export function maxxAiRangeValidator(group: AbstractControl): ValidationErrors | null {
  if (group.root?.get('settings.mode')?.value !== GiftUnlockMode.MAXX_AI) return null;

  const min = group.get('min')?.value;
  const max = group.get('max')?.value;
  const hasMin = min !== null && min !== undefined && min !== '';
  const hasMax = max !== null && max !== undefined && max !== '';

  if (!hasMin || !hasMax) return { [MAXX_AI_RANGE_REQUIRED]: true };
  if (Number(max) <= Number(min)) return { [MAXX_AI_RANGE_INVALID]: true };
  return null;
}
